module.exports = __webpack_public_path__ + "static/partner_bg1-702e82563e82dce0aca1baf8f6934d80.png";